module.exports = "/_next/static/images/second-basquiat-ce5e1bc61e6418011ef4f8a46fa0b746.png";